export async function fetch({ state, commit }, { id, api }) {
  // de-dupe concurrent calls
  if (state.inflight[id]) return state.inflight[id];

  const p = api(id)
    .then((item) => {
      commit("set", { id, item });
      return item;
    })
    .finally(() => commit("clearInflight", id));

  commit("setInflight", { id, p });
  return p;
}
